import OwnerCoownerApiHandler from './OwnerCoownerApiHandler.js';
function getPath(path) {
  const nPath = pathOrObj(path);
  if (typeof nPath !== 'string') {
    return null;
  }
  return nPath;
}
function pathOrObj(pO) {
  if (typeof pO === 'string') {
    return pO;
  }
  return pO && pO.path;
}
export { getPath, OwnerCoownerApiHandler };